import { UNAUTHORIZED_ERROR_STATUS } from './errors';

export const shouldCollapseWidget = (status) => status && status !== UNAUTHORIZED_ERROR_STATUS;
